<div #scrollContainer class="result-container">
  <app-result-filter 
    (sortEmitter)="sortMatchResults($event)"
    (filterFormEmitter)="filterCareerResults($event)"
    (searchEmitter)="filterBasedOnSearch($event)"
  ></app-result-filter>

  <div class="result-div">
    @if (careerMatches.length > 0) {
      @for (item of careerMatches; track $index) {
        <app-result-card 
          [match_item]="item"
          [index]="$index"
          (bookmarkEmitter)="toggleBookmark($event)"
          (cardClickEmitter)="onSelectCareer($event)"
        ></app-result-card>
      }
    } @else {
      <p class="no-result-text">No careers match found.</p>
    }
  </div>
  
  @if (careerMatches.length > 0) {
    <div class="view-more-div">
      @if (hasMoreItems) {
        <button 
          mat-flat-button 
          type="button" 
          class="view-more-btn"
          (click)="loadMore()"
        >
          VIEW MORE
          <img src="/assets/icons/results/down-arrow-teal.svg" class="arrow-class" />
        </button>
      } @else {
        <p class="no-more-data">You've reached the end</p>
      }
      <button 
        type="button"
        class="to-top-btn"
        (click)="scrollToTop()"
        aria-label="Scroll to top"
      >
        TOP
        <img src="/assets/icons/results/up-arrow-teal.svg" class="arrow-class" />
      </button>
    </div>
  }
</div>